import { render } from "./userManual.vue?vue&type=template&id=77c796e4"
import script from "./userManual.vue?vue&type=script&lang=js"
export * from "./userManual.vue?vue&type=script&lang=js"
script.render = render

export default script